<template>
  <div v-if="showAd" class="ad-banner-wrapper">
    <div class="ad-banner" :class="{ collapsed: isCollapsed }">
      <div class="ad-header" v-if="!isCollapsed">
        <span class="ad-label">广告</span>
        <button class="ad-close-btn" @click="isCollapsed = true" title="关闭广告">
          ×
        </button>
      </div>
      <div class="ad-content" v-if="!isCollapsed">
        <div v-if="adSettings.ad_code" v-html="adSettings.ad_code"></div>
        <div v-else class="ad-placeholder">
          <div class="ad-placeholder-icon">📢</div>
          <div class="ad-placeholder-text">广告位</div>
          <div class="ad-placeholder-sub">广告位招租中</div>
        </div>
      </div>
      <button class="ad-restore-btn" v-if="isCollapsed" @click="isCollapsed = false" title="显示广告">
        📢
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdBanner',
  props: {
    position: {
      type: String,
      default: 'image-generate'
    }
  },
  data() {
    return {
      adSettings: {
        enabled: false,
        ad_type: 'banner',
        ad_code: '',
        ad_positions: [],
        display_rule: 'every-time',
        member_exemption: true
      },
      isCollapsed: false,
      isLoading: false
    }
  },
  computed: {
    showAd() {
      if (!this.adSettings.enabled) return false
      if (!this.adSettings.ad_positions.includes(this.position)) return false
      if (this.adSettings.member_exemption && this.isMember) return false
      return true
    },
    isMember() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      const subscription = userInfo.subscription
      return subscription && subscription.has_subscription
    }
  },
  mounted() {
    this.loadAdSettings()
  },
  methods: {
    async loadAdSettings() {
      try {
        const response = await axios.get('/api/ad-setting')
        if (response.data.code === 200) {
          this.adSettings = response.data.data
        }
      } catch (error) {
        console.error('加载广告设置失败:', error)
      }
    },
    collapseAd() {
      this.isCollapsed = true
    },
    restoreAd() {
      this.isCollapsed = false
    }
  }
}
</script>

<style scoped>
.ad-banner-wrapper {
  margin: 20px 0;
}

.ad-banner {
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  min-height: 90px;
  position: relative;
}

.ad-banner.collapsed {
  min-height: auto;
}

.ad-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  background: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
}

.ad-label {
  font-size: 11px;
  color: #999;
  background: #e8e8e8;
  padding: 2px 8px;
  border-radius: 3px;
}

.ad-close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.ad-close-btn:hover {
  color: #666;
}

.ad-content {
  padding: 12px;
  text-align: center;
}

.ad-placeholder {
  padding: 20px;
  color: #999;
}

.ad-placeholder-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.ad-placeholder-text {
  font-size: 14px;
  margin-bottom: 4px;
}

.ad-placeholder-sub {
  font-size: 12px;
  color: #bbb;
}

.ad-restore-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #f0f0f0;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ad-restore-btn:hover {
  background: #e8e8e8;
}
</style>
